import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  siblingCount = 1,
  className = '',
  onLimitChange,
  limitOptions = [10, 25, 50, 100, 500, 1000],
  showSummary = true,
  showLimit = true
}) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Calculate page numbers to display
    const getPageNumbers = () => {
        const totalNumbers = siblingCount * 2 + 3; // First, last, current, and siblings
        const totalBlocks = totalNumbers + 2; // Including ellipses

        if (totalPages <= totalBlocks) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        const startPage = Math.max(2, currentPage - siblingCount);
        const endPage = Math.min(totalPages - 1, currentPage + siblingCount);
        let pages = [];

        // Always show first page
        pages.push(1);

        // Add ellipsis if needed
        if (startPage > 2) {
            pages.push('...');
        }

        // Add page numbers
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        // Add ellipsis if needed
        if (endPage < totalPages - 1) {
            pages.push('...');
        }

        // Always show last page
        if (totalPages > 1) {
            pages.push(totalPages);
        }

        return pages;
    };

    // Handle page change
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    // Don't render if there's no items
    if (totalItems === 0) {
        return null;
    }

  return (
    <div className={`d-flex flex-sm-row justify-content-between align-items-center mt-3 ${className}`}>
            <div className="pageNumber">
                <div className="mb-2 mb-sm-0 me-3">
                    Showing {Math.max((currentPage - 1) * itemsPerPage + 1, 1)} to{' '}
                    {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                </div>
                <select
                    value={itemsPerPage}
                    onChange={(e) => onLimitChange(e.target.value)}
                    className="form-select form-select-sm"
                    style={{ width: '80px' }}
                >
                    {limitOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>
            {totalPages <= 1 ? null : (
                <nav aria-label="Pagination">
                    <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                aria-label="Previous page"
                            >
                                Previous
                            </button>
                        </li>

                        {getPageNumbers().map((page, index) => (
                            <li
                                key={index}
                                className={`page-item ${page === '...' ? 'disabled' : ''} ${page !== '...' && currentPage === page ? 'active' : ''
                                    }`}
                            >
                                {page === '...' ? (
                                    <span className="page-link">...</span>
                                ) : (
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(page)}
                                        aria-current={currentPage === page ? 'page' : undefined}
                                        aria-label={`Page ${page}`}
                                    >
                                        {page}
                                    </button>
                                )}
                            </li>
                        ))}

                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                aria-label="Next page"
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
};

export default Pagination;